import 'tailwindcss'   
import './style.css'
import { initSlideAnimation } from './slideAnimation.js'
import { initLineAnimation } from './lineAnimation.js'
import { initNavigation } from './navigation.js'

// HTMLが読み込まれた後に実行
document.addEventListener('DOMContentLoaded', () => {
  
  initSlideAnimation();
  initLineAnimation();
  initNavigation();
  
});
